import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import JourneyHeader from "@/components/JourneyHeader";
import {
  AlertDialog, AlertDialogAction, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle
} from "@/components/ui/alert-dialog";

const FinalRejectState = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isCallbackOpen, setIsCallbackOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-intellend-white flex flex-col">
      <JourneyHeader />

      <main className="px-3 py-3 flex-1 flex flex-col justify-center max-w-md mx-auto w-full">
        <div className="bg-white shadow-md rounded-lg p-4 mb-auto mt-auto">
          <div className="text-center py-6">
            <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
              <p className="text-red-600 font-semibold text-lg">
                We are periodically adding new offers. Please check back with us when newer offers are available.
              </p>
            </div>

            <p className="text-gray-600 mb-6">
              We apologize for any inconvenience.
            </p>

            <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
              <Button
                type="button"
                onClick={handleLogout}
                className="w-full sm:w-auto bg-intellend-green hover:bg-intellend-green/90"
              >
                Log Out
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FinalRejectState;
